import React from 'react'
import { Outlet } from 'react-router-dom'

const ConsumersLayout: React.FC = () => {
  return <Outlet />
}

export default ConsumersLayout
